import { render, staticRenderFns } from "./ReportReverseLogistics.vue?vue&type=template&id=77c5de3a"
import script from "./ReportReverseLogistics.vue?vue&type=script&lang=js"
export * from "./ReportReverseLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports